import { theme as baseTheme } from '../aidu/index.js';
export const colors = {
  ...baseTheme.colors,
  contentBrand: '#064B7A',
  interactionSuccess: '#74A314',
  interactionSuccessHover: '#689312',
  interactionSuccessPressed: '#5D8210',
  interactionPrimary: '#74A314',
  interactionPrimaryHover: '#689312',
  interactionPrimaryPressed: '#5D8210',
  interactionSecondary: '#0079CF',
  interactionSecondaryHover: '#006DBA',
  interactionSecondaryPressed: '#0061A6',
  interactionDanger: '#DA4833',
  interactionDangerHover: '#C4412E',
  interactionDangerPressed: '#AE3A29',
  backgroundBrand: '#064B7A',
  backgroundBrandDark: '#053C62',
  backgroundInteractionSecondaryTransparentDark: 'rgba(6, 75, 122, 0.8)',
  backgroundInteractionSecondaryTransparentLight: 'rgba(6, 75, 122, 0.3)',
  backgroundStateSelectedTransparent: 'rgba(6, 75, 122, 0.1)',
  backgroundStateSelected: '#E6EDF2',
  borderSelection: '#0079CF',
  systemError: '#DA4833',
  systemErrorAlert: '#AE3A29',
  systemErrorBackground: '#FBEDEB',
  systemErrorHover: '#C4412E',
  systemErrorBackgroundHover: '#F8DAD6',
  systemErrorBackgroundPressed: '#F4C8C2',
  systemPositive: '#74A314',
  systemPositiveHover: '#689312',
  systemPositiveAlert: '#5D8210',
  systemPositiveBackground: '#F1F6E7',
  systemPositiveBackgroundHover: '#E3EDD0',
  systemPositiveBackgroundPressed: '#D5E3B8',
  brandA: '#064B7A',
  brandB: '#74A314',
  // component specific overrides, use sparingly!
  buttonPrimaryInfoColor: '#222222',
  // contentPrimary
  buttonPrimarySuccessColor: '#222222',
  // contentPrimary
  buttonPrimaryWarningColor: '#222222' // contentPrimary
};